import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

export const fullScreenModalStyles = css`
  width: 100%;
  height: 100%;
  max-width: unset;
  margin: 2.4rem;
  max-height: calc(100% - 4.8rem);
  overflow: hidden;
`;

export const FULL_SCREEN_MODAL_CLASSES = {
  paper: cn('rounded-16 shadow-04', fullScreenModalStyles),
};

export const minHeightZero = css`
  min-height: 0;
`;
